export enum RolesListColumns {
  NAME = 'Name',
  SCHOOL = 'School',
  ACTIONS = 'Actions'
}
